import { Box, Button, Text, Flex, Image } from 'rebass';
import { Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom';
import React, { useCallback, useState, useContext, useEffect } from 'react';
import store from 'store';
import useSWR from 'swr';
import { FiGift } from "react-icons/fi";
import StoryMutePopup from 'stories/mute/popup';
import { CollectionTooltipProvider } from '../collection-tooltip-context';
import { CurrentCollectionContext } from '../current-collection-context';
import { useWindowSize } from 'react-use';
import { useEntity } from '../../entities/hooks';
import AddStory from '../../stories/new-story-popup';
import AnimatedNavWrap from '../../app/navigation/animated-nav-wrap';
import CollectionStories from './stories';
import CollectionStoryOptions from './story-options';
import Delete from './delete';
import DeleteShare from './delete/delete-share';
import EditCollection from '../edit';
import ExportCollection from './export';
import Milestones from '../../memoirs/milestones';
import NewStoryRequestsModal from './story-requests/new';
import Participants from './participants';
import StoryRequestDetail from './story-requests/detail';
import StoryRequestResponse from './story-requests/response';
import StoryRequestDelete from './story-requests/delete';
import StoryRequestsModal from './story-requests';
import SubscriptionBanner from '../../members/profile/subscription/banner';
import TagManagement from './tag-management/collection';
import StoryTagsModal from '../../stories/tags/modal';
import RemoveStoryFromCollection from './remove-story-from-collection';
import NewStoryRequest from './story-requests/new/new-story-request';
import useEntities from 'entities/hooks/use-entities';
import FetaureComingSoon from 'app/FetaureComingSoon';
import apiBase from 'utils/api-base';
import Paywall from 'paywall/index';
import useCurrentMemberId, { useCurrentMember } from 'members/hooks/index';
import { getSWR } from 'utils/api';
import PandaMomAndPup from './assets/PandaMomAndPup.png';

const baseUrl = apiBase

function IdeasSection({ isFromDesktop }) {

  return <Flex flexDirection={isFromDesktop ? "row" : "column"} alignItems="center" py={2}
    sx={{
      display: isFromDesktop ? ['none', 'none', 'flex'] : ['flex', 'flex', 'none'],
      position: isFromDesktop ? 'relative' : 'fixed',
      bottom: 0,
      left: 0,
      borderTop: isFromDesktop ? 'unset' : '1px solid #64748B',
      background: isFromDesktop ? 'unset' : '#fff',
      width: isFromDesktop ? 'max-content' : '100%',
    }}
    onClick={() => window.open('https://babyyearbooks.com/pages/baby-book-ideas', '_blank', 'noopener,noreferrer')}
  >
    <Text
      color="#737373"
      fontSize={16}
      textAlign={"center"}
      fontFamily="Poppins"
      lineHeight="150%"
      fontWeight={400}
      letterSpacing="-0.32px"
    >
      Looking for inspiration?{isFromDesktop ? '' : <Text as="span" color="#64748B" fontWeight={500}> View Story Ideas {'>'}</Text>}
    </Text>
    {isFromDesktop && <Button
      bg="#fff"
      ml={1}
      sx={{ borderRadius: '23px', border: '1px solid #64748B', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      color={"#64748B"}
    >
      View Story Ideas {'>'}
    </Button>}
  </Flex>
}

const CollectionDetail = () => {
  const params = useParams();
  const { id, type } = params
  const { replace, push } = useHistory();
  const { width } = useWindowSize();
  useSWR(`/v3/child_journals/${id}`, getSWR, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  });

  const child_journals = useEntities('child-journals')
  let childJournal = child_journals[id]

  const onClose = useCallback(() => replace(`/${type}/${id}`), [replace, type, id]);
  const { setCurrentCollection } = useContext(CurrentCollectionContext);
  const memberId = useCurrentMemberId();
  const member = useCurrentMember();

  useSWR(`/v2/members/${memberId}/identifiers`, getSWR, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  });

  const chapters = useEntities('chapter')
  const currentChapter = chapters[params?.['chapter_id']];

  const { isPresent, entity } = useEntity(params);
  const location = useLocation();

  const isOnFreeTrial = entity?.['free-trial'] || false;
  const storyCount = entity?.['story-count'] || 0;

  useEffect(() => {
    setCurrentCollection(params);
    // eslint-disable-next-line
  }, []);
  const [canCreateStory, setCanCreateStory] = useState(null);

  useEffect(() => {
    async function checkStoryEligibility() {
      try {
        const token = store.get('auth_token');

        const response = await fetch(baseUrl + '/stories', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'PREFLIGHT_ONLY': true,
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify({ 'journal-id': id }),
        });

        if (response.status === 200 || response.status === 201) {
          setCanCreateStory(true);
        } else {
          setCanCreateStory(false);
        }
      } catch (error) {

      }
    }

    if (id && type)
      checkStoryEligibility();

  }, [id])


  if (isPresent)
    return (
      <Box m={width < 600 ? 2 : 4} mt={2} mr={2}>
        <CollectionTooltipProvider>
          <SubscriptionBanner />
          {currentChapter ?
            <>
              {/* <Text fontFamily="Poppins" color="#64748B" fontSize={14} letterSpacing="0.14px" lineHeight="165%">
                Chapter {currentChapter?.position + 1}
              </Text> */}
              <Text fontFamily="Poppins" fontSize={22} mb={4} letterSpacing="0.22px" lineHeight="165%">
                {currentChapter?.name}
              </Text>
            </>
            : <Flex justifyContent="space-between" alignItems="center" mb={[2, 4]}>
              <Box>
                <Text fontFamily="Poppins" fontSize={22} letterSpacing="0.22px" lineHeight="165%">
                  Recent Memories
                </Text>
                <Text fontFamily="Poppins" color="#64748B" fontSize={14} letterSpacing="0.14px" lineHeight="165%">
                  Sorted by most recent
                </Text>
              </Box>
              <IdeasSection isFromDesktop={width > 600} />
            </Flex>}
          <CollectionStories isOnFreeTrial={isOnFreeTrial} chapter_id={params.chapter_id} {...params} />
          <AnimatedNavWrap location={location}>
            <Route path="/:type/:id/edit" component={EditCollection} key="edit-collection" />
            <Route
              path="/:type/:id/add-story"
              render={props => {
                return (
                  <AddStory
                    {...props}
                    handleClose={onClose}
                    collection={{ type: params.type, id: params.id }}
                  />
                );
              }}
              key="add-story"
            />
            <Route path="/:type/:id/delete-share" component={DeleteShare} key="delete-share" />
            <Route path="/:type/:id/delete" component={Delete} key="delete" />
            <Route
              path="/:type/:id/manage/tags"
              render={() => <TagManagement collection={params} />}
              key="tag-management"
            />
            <Route path="/:type/:id/participants" component={Participants} key="participants" />
            <Route path="/:type/:id/export" component={ExportCollection} key="export-collection" />
            <Route path="/memoirs/:id/life-events" component={Milestones} />
            <Route path="/:type/:id/story-options/:storyId" component={CollectionStoryOptions} />
            <Route path="/:type/:id/memoir-request-story" component={NewStoryRequest} />
            <Route path="/:type/:id/memoir-request-story/:created_memoir_story_request_id" component={NewStoryRequest} />
            <Route path="/:type/:id/feature-coming-soon/:feature_name" component={FetaureComingSoon} />
            <Route path="/:type/:id/remove-story/:storyId" component={RemoveStoryFromCollection} />
            <Route
              path="/:type/:id/story-tags/:storyId"
              render={routeProps => {
                const {
                  match: { params: routeParams },
                  history,
                } = routeProps;
                return (
                  <StoryTagsModal
                    storyId={routeParams.storyId}
                    onBack={() => history.replace(`/${routeParams.type}/${routeParams.id}`)}
                    onClose={() => history.replace(`/${routeParams.type}/${routeParams.id}`)}
                    {...routeProps}
                  />
                );
              }}
            />
            <Route
              path="/:type/:id/mute/:storyId"
              render={routeProps => {
                const {
                  match: { params: routeParams },
                  history,
                } = routeProps;
                return (
                  <StoryMutePopup
                    storyId={routeParams.storyId}
                    onClose={() => history.replace(`/${routeParams.type}/${routeParams.id}`)}
                    {...routeProps}
                  />
                );
              }}
            />
          </AnimatedNavWrap>
          <Switch>
            <Route path="/:type/:id/story-requests/new" component={NewStoryRequestsModal} />
            <Route path="/:type/:id/paywall" component={Paywall} />

            <Route
              path="/:type/:id/story-requests/:storyRequestId/response"
              component={StoryRequestResponse}
            />
            <Route
              path="/:type/:id/story-requests/:storyRequestId/delete"
              component={StoryRequestDelete}
            />
            <Route
              path="/:type/:id/story-requests/:storyRequestId"
              component={StoryRequestDetail}
            />
            <Route path="/:type/:id/story-requests" component={StoryRequestsModal} />

          </Switch>
          {(storyCount > 0 && isOnFreeTrial) && <Flex flexDirection="column" alignItems="center" my={6} >
            <Text
              color="#0E0E0E"
              fontSize={22}
              fontFamily="Bitter"
              lineHeight="120%"
              fontWeight={400}
              letterSpacing="-0.132px"
            >
              Enjoying Baby Yearbooks?
            </Text>
            <Button
              p="10px 30px"
              height={44} mt={3}
              sx={{ borderRadius: '23px', color: '#fff', fontFamily: 'Poppins', fontWeight: 500, fontSize: '16px', lineHeight: '125%', letterSpacing: '-0.096px' }}
              onClick={() => {
                window.open(childJournal?.['bundle-purchase-url'] + `?email=${encodeURIComponent(member)}`, '_blank')
                // replace(`/${type}/${id}/paywall?step=1`)
              }}
            >
              Upgrade or give as a gift
            </Button>
          </Flex>}
          {storyCount === 0 &&
            <Flex flexDirection="column" alignItems="center" my={6} >
              <Image src={PandaMomAndPup} maxWidth={253} mb={2} />
              <Text
                color="#737373"
                fontSize={16}
                textAlign={"center"}
                fontFamily="Poppins"
                lineHeight="150%"
                fontWeight={400}
                letterSpacing="-0.32px"
              >
                No stories created yet.<br />
                Start capturing your baby’s beautiful story!
              </Text>
            </Flex>}

          <IdeasSection />
        </CollectionTooltipProvider>
      </Box>
    );

  return false;
};

export default CollectionDetail;
